module.exports = __webpack_public_path__ + "static/media/RP-52.3813b317.pdf";